<template>
	<SOSlotModal
		:modal-title="'Impor Data ' + context"
		:modal-id="id"
		@close="close"
	>
		<template v-slot:modal-body>
			<div class="font-16 remove-padding-margin desciption-txt-modal">
				File yang diupload harus berupa file excel dengan format penulisan sesuai dengan contoh
				berikut:
			</div>
			<div class="div-impor mar-top-bot-15 color-206CF" @click="importTemplate">
				<img class="" src="../../../assets/icons/download.svg" alt="">
				Template Data {{ context }}
			</div>
			<div class="mar-bottom-16 desciption-txt-modal">
				Jika sudah sesuai dengan template, silahkan upload file melalui kotak dibawah ini.
			</div>
			<div class="line-patah mar-bottom-20">
				<div class="atribute" id="imagePreview">
					<label for="import-area">
						<img src="../../../assets/icons/file-plus.svg" alt=""
						     style="max-width: 70px" id="logo">
						<br>
						<span>Klik untuk memilih file...</span>
					</label>
					<input type='file'
					       id="import-area"
					       ref="file"
					       accept=".xlsx"
					       @change="importData"
					/>
				</div>
			</div>
		</template>
	</SOSlotModal>
</template>

<script>
import SOSlotModal from "@/so-components/global/slot/SOSlotModal";

export default {
	name: "SOModalImport",
	components: {
		SOSlotModal,
	},
	props: {
		context: String,
		urlImportTemplate: String,
	},
	data() {
		return {
			id: "modal-import",
		}
	},
	mounted() {
		$("#" + this.id).modal("show");
	},
	methods: {
		close() {
			$("#" + this.id).modal("hide");
			setTimeout(() => {
				this.$emit("close")
			}, 500)
		},
		importTemplate() {
			window.open(this.urlImportTemplate, '_blank');
			this.flutterDownload(this.urlImportTemplate)
		},
		importData() {
			let payload = {
				fileExcel: this.$refs.file.files[0]
			}

			$("#" + this.id).modal("hide");
			setTimeout(() => {
				this.$emit("import-process", payload)
			}, 500)
		},
	}
}
</script>

<style scoped>
.div-impor {
	background: #F8F8F8;
	padding: 10px 12px;
	border-radius: 4px;
}
</style>